import React from 'react';
import ReactDOM from 'react-dom/client';
import GlobalErrorBoundary from './GlobalErrorBoundary';
import './index.css';
import App from './App';
import './firebase'; // Initialize Firebase
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </React.StrictMode>
);

// Unregister all service workers and clear cache to fix ChunkLoadError
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => {
        const hadRegistrations = registrations.length > 0;
        registrations.forEach(registration => registration.unregister());
        console.log('Service workers unregistered');
        return hadRegistrations;
      })
      .then((hadRegistrations) => {
        if ('caches' in window) {
          return caches.keys().then((keys) => {
            return Promise.all(keys.map((key) => caches.delete(key))).then(() => {
              return hadRegistrations || keys.length > 0;
            });
          });
        }
        return hadRegistrations;
      })
      .then((needsReload) => {
        console.log('All caches cleared');
        // Auto-reload once if we cleared anything
        if (needsReload && !sessionStorage.getItem('cache_cleared_reload')) {
          sessionStorage.setItem('cache_cleared_reload', '1');
          console.log('Reloading to apply cache clear...');
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log('Cache clearing failed:', error);
      });
  });
}

// Performance monitoring with Web Vitals
reportWebVitals((metric) => {
  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log(metric);
  }

  // Send to analytics in production
  if (process.env.NODE_ENV === 'production' && window.gtag) {
    window.gtag('event', metric.name, {
      event_category: 'Web Vitals',
      value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      event_label: metric.id,
      non_interaction: true,
    });
  }
});
